import { render, staticRenderFns } from "./UserValidSettings.vue?vue&type=template&id=828a1ae2&"
import script from "./UserValidSettings.vue?vue&type=script&lang=js&"
export * from "./UserValidSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports